module.exports = __webpack_public_path__ + "img/vendor.8fbf2798.svg";